// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VehicleGroupAreaId } from './VehicleGroupAreaId'
import { VehicleGroupAreaNavigation } from './VehicleGroupAreaNavigation'
import { VehicleGroupAreaRoutes } from './VehicleGroupAreaRoutes'

const LazyVehicleGroupComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./VehicleGroupArea')),
)

const VehicleGroupComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehicleGroupComponent />
  </SuspenseLoadingWrapper>
)

export const VehicleGroupArea = {
  id: VehicleGroupAreaId,
  requiredRight: BoumRight.AREA_VEHICLE_GROUP,
  NavigationComponent: VehicleGroupAreaNavigation,
  route: {
    path: VehicleGroupAreaRoutes.route,
    component: VehicleGroupComponent,
  },
}
